import styled from "styled-components"; 

export const ContainerNoti = styled.div`
    width: 100%; 
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .line-separation { 
        width: 90%;
        height: 9px;
        background: linear-gradient(180deg, #C4C4C4 0%, rgba(196, 196, 196, 0) 100%);
        @media (max-width: 768px){
            width: 100%;
            background: linear-gradient(180deg, rgba(196, 196, 196, 0.7) 0%, rgba(196, 196, 196, 0) 100%);
        }
    }
     @media (max-width: 768px){
        background-color: var(--color-grey95);
    }
`;

